import { connect } from "react-redux";
import {
  isDisplayed,
  getAdSpecificTargeting,
  getPriorProductsFingerprint,
  getSizeMappingIndex
} from "../../state/modules/adverts";
import withAdverts from "../../components/withAdverts";

const mapStateToProps = state => ({
  isDisplayed: isDisplayed(state),
  targeting: getAdSpecificTargeting(state),
  priorProductsFingerprint: getPriorProductsFingerprint(state),
  sizeMappingIndex: getSizeMappingIndex(state)
});

export default component => connect(mapStateToProps)(withAdverts(component));
